import { useState, useEffect, HtmlHTMLAttributes, FC } from 'react';

import css from './Img.module.css';

export interface Props extends HtmlHTMLAttributes<HTMLImageElement> {
  src: string;
  width?: string | number;
  height?: string | number;
}

const Img: FC<Props> = ({ src, height = 300, width, ...props }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    if (!src) {
      setError(true);
      setIsLoading(false);
      return;
    }

    setIsLoading(true);
    setError(false);

    const image = new Image();
    image.src = src;

    image.onload = () => {
      setIsLoading(false);
      setError(false);
    };

    image.onerror = () => {
      setIsLoading(false);
      setError(true);
    };

    // Clean up function to prevent memory leaks if the component unmounts before image loads
    return () => {
      image.onload = null;
      image.onerror = null;
    };
  }, [src]);

  if (isLoading) {
    return <div className={css.img__loading} style={{ height, width }} />;
  }

  if (error) {
    <div className={css.img__error} style={{ height, width }}>
      Error loading image
    </div>;
  }

  return <img {...props} src={src} className={css.img} height={height} width={width} />;
};

export default Img;
